import { render, staticRenderFns } from "./warZone.vue?vue&type=template&id=12be78c6&scoped=true&"
import script from "./warZone.vue?vue&type=script&lang=js&"
export * from "./warZone.vue?vue&type=script&lang=js&"
import style0 from "./warZone.vue?vue&type=style&index=0&id=12be78c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12be78c6",
  null
  
)

export default component.exports